import React from 'react';

export const ReloadButton = ({ onReload }) => {
    const [sending, setSending] = React.useState(false);
	const handleClick = (e) => {
        e.preventDefault();
        setSending(true);
		onReload?.().finally(() => {
            setSending(false); 
        });
	};

	return (
		<div className="ellipsis" onClick={handleClick}>
			<button disabled={sending}></button> <label id='copyLabel'>Recargar lista</label>
		</div>
	);
};

export default ReloadButton;
